import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-572c7670")

_pushScopeId("data-v-572c7670")
const _hoisted_1 = { class: "row container" }
const _hoisted_2 = { class: "nav-tree" }
const _hoisted_3 = { class: "list" }
const _hoisted_4 = { class: "col h-full align-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_category_tree = _resolveComponent("category-tree")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_tag_creator = _resolveComponent("tag-creator")
  const _component_el_table = _resolveComponent("el-table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_category_tree, {
        categoryType: "TAG",
        onNodeClick: _ctx.filterCategory
      }, null, 8, ["onNodeClick"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          height: "100%",
          class: "w-full"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_table_column, {
              prop: "category",
              label: "类型",
              width: "120"
            }, {
              default: _withId((scope) => [
                _createVNode("div", null, _toDisplayString(scope.row.category?.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "tags",
              label: "标签"
            }, {
              default: _withId((scope) => [
                _createVNode(_component_tag_creator, {
                  onTagCategoryUpdated: _ctx.tagCategoryUpdated,
                  categoryId: scope.row.category?.id,
                  modelValue: scope.row.tags,
                  "onUpdate:modelValue": ($event: any) => (scope.row.tags = $event)
                }, null, 8, ["onTagCategoryUpdated", "categoryId", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ])
    ])
  ]))
})